import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import { translate } from '../../../../../react/features/base/i18n/functions';
import Icon from '../../../../../react/features/base/icons/components/Icon';
import { IconCopy } from '../../../../../react/features/base/icons/svg';
import { copyText } from '../../../../../react/features/base/util/copyText';
import DialInNumber
from '../../../../../react/features/invite/components/add-people-dialog/web/DialInNumber';
import {
    getDialInfoPageURL,
    hasMultipleNumbers
} from '../../../../../react/features/invite/functions';
import { getDialInObjectByLang } from '../../../../../wildix/components/invite/functions';
const useStyles = makeStyles()(theme => {
    return {
        link: {
            color: theme.palette.link01,

            '&:hover': {
                color: theme.palette.link01Hover
            }
        }
    };
});

function DialinNumbers() {
    const conferenceID = useSelector(state => state['features/invite'].conferenceID);
    const { t } = useTranslation();
    const dialIns = useSelector(state => state['features/invite']);
    const dialIn = getDialInObjectByLang(dialIns.numbers);
    const [ phoneNumber = null ] = dialIn?.phones || [];
    const countryName = dialIn?.countryName;
    const showMoreNumbers = useSelector(state => hasMultipleNumbers(state['features/invite'].numbers));
    const dialInfoPageUrl = useSelector(getDialInfoPageURL);
    const { classes, cx } = useStyles();

    const onCopyText = useCallback(({ phone, conferenceID: conferenceIDParam }) => {
        const textToCopy = conferenceIDParam ? `${phone},${conferenceIDParam}` : `${phone}`;

        copyText(textToCopy);
    }, []);

    return (
        <div className='invite-dialog-xbees'>
            <h2>
                {t('addPeople.inviteToWizyconfStation')}
            </h2>
            {
                phoneNumber && <DialInNumber
                    conferenceID={conferenceID ?? ''}
                    phoneNumber={phoneNumber}/>
            }
            <div className='separator'/>
            <h2 className='margin-top_10'>
                {t('addPeople.inviteDialInTitle')}
            </h2>
            <h3>{t('addPeople.inviteDialInDescription')}</h3>
            <div className='dial-in-line'>
                <span>{phoneNumber},</span>
                <span className='dial-in-space_left'>{conferenceID}</span>
                <span className='dial-in-country dial-in-space_left'>({countryName})</span>
                <a
                    aria-label={t('info.copyNumber')}
                    className='dial-in-copy'
                    onClick={() => onCopyText({
                        phone: phoneNumber,
                        conferenceID
                    })}
                    role='button'
                    tabIndex={0}>
                    <Icon src={IconCopy}/>
                </a>
            </div>
            <div className='separator'></div>
            <h3>{t('addPeople.inviteDialInNumbers')}</h3>
            <div className='dial-in-line'>
                <span>{phoneNumber}</span>
                <span className='dial-in-country dial-in-space_left'>({countryName})</span>
                <a
                    aria-label={t('info.copyNumber')}
                    className='dial-in-copy'
                    onClick={() => onCopyText({ phone: phoneNumber })}
                    role='button'
                    tabIndex={0}>
                    <Icon src={IconCopy}/>
                </a>
            </div>
            <div className='separator'/>
            {showMoreNumbers ? <a
                className={cx('more-numbers', classes.link)}
                href={dialInfoPageUrl}
                rel='noopener noreferrer'
                target='_blank'>
                {t('info.moreNumbers')}
            </a> : null}
        </div>
    );
}

export default connect(null, null)(translate(DialinNumbers));
